// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'profile-section',
    templateUrl: './profile-section.component.html',
    styleUrls: ['./profile-section.component.scss'],
})
export class ProfileSectionComponent {
    @Input() userProfileIsComplete = false;
    @Input() title: string;
    @Input() defaultOpen: boolean = null;
    @Input() titleTooltip: string;
    @Output() toggled: EventEmitter<any> = new EventEmitter();
    collapsed = true;
    private defaultedOpen = false;

    ngOnChanges(changes: SimpleChanges): void {
        this.defaultOpenSection();
    }

    toggleCollapsed() {
        this.collapsed = !this.collapsed;
        this.toggled.emit({
            context: 'section-toggled',
            data: {
                title: this.title,
                collapsed: this.collapsed,
            },
        });
    }

    defaultOpenSection() {
        if (this.defaultOpen && !this.defaultedOpen) {
            this.defaultedOpen = true;
            this.toggleCollapsed();
        }
    }
}
